import { useMemo } from 'react';

import { ChevronRightIcon } from '@radix-ui/react-icons';
import { DataTable, Flex, Text } from '@raystack/apsara';

import styles from '@src/components/Custom/ModelCommonComponents/styles.module.css';

import { parentClasses } from './CategoricalView';

export interface CategoricalTableProps {
  parentClass: string;
  data: parentClasses;
}

type cell = {
  row: {
    original: {
      [key: string]: string | number;
    };
  };
};

export const CategoricalTable = ({
  data,
  parentClass
}: CategoricalTableProps) => {
  const columns = [
    {
      header: 'From > To',
      accessorKey: 'parent_class',
      cell: ({ row: { original: item } }: cell) => (
        <Flex gap='small' align='center'>
          <div
            style={{
              width: '16px',
              height: '16px',
              borderRadius: '2px',
              backgroundColor: `${item.color}`
            }}
          />
          <Text size={4} weight={400} variant='secondary'>
            <Flex gap='small' align='center'>
              {item.parent_class}
              <ChevronRightIcon />
              {item.child_class}
            </Flex>
          </Text>
        </Flex>
      )
    },
    {
      header: 'Area',
      accessorKey: 'area',
      cell: ({ row: { original: item } }: cell) => (
        <Text size={4} weight={400} variant='secondary'>
          {item.percentage} ({item.area} km<sup>2</sup>)
        </Text>
      )
    }
  ];

  const tableData = useMemo(() => {
    if (Object.keys(data).length > 0) {
      const currentChildClasses = data[parentClass] ?? [];
      const reducedChildClasses = currentChildClasses.map(item => ({
        parent_class: parentClass,
        child_class: item['Comparison class name (After)'],
        color: item['colors'],
        area: item['Area in km2'],
        percentage: Number(item['Area in percentage']).toFixed(2) + '%'
      }));

      return reducedChildClasses.filter(
        i => i.color !== '' && Number(i.area) !== 0
      );
    }

    return [];
  }, [data, parentClass]);

  return (
    <div className={styles.tableWrapper}>
      <DataTable data={tableData} columns={columns}>
        <DataTable.Content />
      </DataTable>
    </div>
  );
};
